import { DataBean } from "../DataBean";

export class OrderTowip extends DataBean {



    public async getProductionOrderToWIPCatalog(idProductionOrder:any,productionOrderDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProductionOrderToWIPCatalog_Number_java.util.Date", [idProductionOrder,productionOrderDate]);
    }

    
}